import { getPreferredLanguage, getVenueLanguage } from 'src/tracking/utils/context';
import App from 'common/backbone-app';
import { getSalesForceLocale } from 'common/salesforce-bot/getSalesForceLocale';
import { FAKE_MASQUERADING_EMAIL } from 'common/salesforce-bot/constants';

export const getExternalUserFullName = (
  accountFullName: string,
  accountFirstName?: string,
  maxLength = 100,
): string => {
  const isFullNameShortEnough = accountFullName.length <= maxLength;
  if (isFullNameShortEnough) {
    return accountFullName;
  }
  return accountFirstName?.substring(0, maxLength) || 'Anonymous User';
};

export const getChatLocale = () => {
  const preferredLocale = getPreferredLanguage();
  const salesforceVenueLocale = getVenueLanguage();
  return preferredLocale || salesforceVenueLocale;
};

export type LoggedUserInfo = {
  fullName: string;
  language: any;
  country: any;
  userId: string;
  venueId: any;
  email: any;
};

export const getLoggedUserInfo = (): LoggedUserInfo => {
  const accountFullName = App.config.accountFullName();
  const accountFirstName = App.config.get('account')?.firstName;
  const venue = App.config.get('venue');
  const account = App.config.get('account');
  return {
    fullName: getExternalUserFullName(accountFullName, accountFirstName),
    language: getSalesForceLocale(),
    country: venue.countryCode,
    venueId: venue.id,
    userId: App.config.getAccountId(),
    email: App.isMasquerading() ? FAKE_MASQUERADING_EMAIL : account.emailAddress,
  };
};
